var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedemptionBackArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 10.8257 11.6171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 19
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00005 11.6171C4.83453 11.6181 4.67247 11.5697 4.53453 11.4782C4.3966 11.3867 4.28904 11.2562 4.22557 11.1033C4.1621 10.9505 4.14559 10.7822 4.17815 10.6199C4.2107 10.4576 4.29085 10.3087 4.40838 10.1921L8.82505 5.78376L4.40838 1.37543C4.27186 1.21601 4.20052 1.01095 4.20862 0.80122C4.21672 0.59149 4.30366 0.39254 4.45208 0.244128C4.60049 0.0957162 4.79944 0.00877293 5.00917 0.00067197C5.2189 -0.00742899 5.42396 0.0639094 5.58338 0.200431L10.5834 5.20043C10.7386 5.35657 10.8257 5.56778 10.8257 5.78793C10.8257 6.00809 10.7386 6.2193 10.5834 6.37543L5.58338 11.3754C5.42816 11.5294 5.21866 11.6162 5.00005 11.6171Z",
    fill: "url(#paint0_linear_0_18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.628116 9.78368C0.504078 9.78434 0.382635 9.7512 0.279271 9.68847C0.175906 9.62575 0.0953036 9.53628 0.0477386 9.43149C0.000173679 9.32669 -0.0121983 9.21132 0.0122001 9.10007C0.0365985 8.98881 0.0966618 8.88673 0.184732 8.80683L3.4945 5.78486L0.184732 2.76289C0.0671396 2.65531 0.00107663 2.50942 0.00107663 2.35729C0.00107663 2.20516 0.0671396 2.05927 0.184732 1.95169C0.302325 1.84412 0.461815 1.78369 0.628116 1.78369C0.794417 1.78369 0.953907 1.84412 1.0715 1.95169L4.81841 5.37926C4.93472 5.48629 5 5.63108 5 5.782C5 5.93292 4.93472 6.07771 4.81841 6.18474L1.0715 9.6123C1.01366 9.66628 0.944693 9.70922 0.868583 9.73864C0.792474 9.76806 0.71074 9.78337 0.628116 9.78368Z",
    fill: "url(#paint1_linear_0_18)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_18",
    x1: 10.8257,
    y1: 5.80859,
    x2: 4.16187,
    y2: 5.80859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_18",
    x1: 5,
    y1: 5.7837,
    x2: 0,
    y2: 5.7837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionBackArrow);
export default __webpack_public_path__ + "static/media/redemption-back-arrow.c7396969a6ba6e82bdd4c28a4e1ca03c.svg";
export { ForwardRef as ReactComponent };